<div class="mui-hero">
  <ng-container [ngTemplateOutlet]="bannerSection"></ng-container>

  <!-- Default Hero Header -->
  <div class="mui-hero__default-container" role="region">
    <div class="mui-hero__bg" [class]="getBgImgClass(content)" [style.background-image]="getBgImg(content)"></div>

    <div
      muiStickyOffsetAnchor
      class="mui-hero__app-bar"
      [class.mui-hero__app-bar--sticky]="sticky$ | async"
      [@stickyHeaderAnimation]="sticky$ | async"
      [class.collapsed-sidebar]="getCollapsedstate() | async"
      [class.full-sidebar]="(getCollapsedstate() | async) === false">
      <div class="mui-hero__app-bar--left">
        <ng-container *ngTemplateOutlet="leftAppBar"></ng-container>
      </div>

      <!-- Breadcrumbs - shown on desktops (md-xl) -->
      <ng-container *ngIf="sticky$ | async">
        <ng-container *ngTemplateOutlet="breadcrumbs"></ng-container>
        <div *ngIf="pageTitle" class="mui-hero__app-bar--sticky-title">{{ pageTitle }}</div>
      </ng-container>

      <a class="mui-hero__logo-link" [href]="routingOptions.homeUrl">
        <div id="miele-logo" class="mui-hero__logo-img mui-logo"></div>
      </a>

      <div class="mui-hero__app-bar--right">
        <ng-container [ngTemplateOutlet]="rightAppBar"></ng-container>
      </div>

      <!-- Banner above hero area -->
      <ng-container *ngIf="sticky$ | async">
        <ng-container [ngTemplateOutlet]="bannerSection"></ng-container>
      </ng-container>
    </div>

    <ng-container [ngTemplateOutlet]="content?.titleTemplate"></ng-container>
  </div>
</div>

<div class="mui-hero__toolbar-container">
  <div *ngIf="breadcrumbTemplate" class="mui-hero__breadcrumbs-container">
    <mui-breadcrumbs [labelTemplate]="breadcrumbTemplate" class="mui-hero__breadcrumbs"></mui-breadcrumbs>
  </div>
  <div class="mui-hero__buttons-container">
    <ng-container [ngTemplateOutlet]="content?.toolbarTemplate"></ng-container>
  </div>
</div>

<ng-template #bannerSection>
  <div *ngIf="banner" class="mui-hero__banner">
    <ng-container *ngTemplateOutlet="banner"></ng-container>
  </div>
</ng-template>

<ng-template #leftAppBar>
  <!-- App Bar - shown in mobile (xs-md) -->
  <button id="main-menu-button" class="mui-hero__app-bar__button" (click)="mainMenuService?.toggleMobileOpen()">
    <mui-icon name="bars" font="fa"></mui-icon>
  </button>
</ng-template>

<ng-template #breadcrumbs>
  <!-- Breadcrumbs - shown on desktops (md-xl) -->
  <div *ngIf="breadcrumbTemplate" class="mui-hero__breadcrumbs-container">
    <mui-breadcrumbs [labelTemplate]="breadcrumbTemplate" class="mui-hero__breadcrumbs"></mui-breadcrumbs>
  </div>
</ng-template>
